export default "__VITE_ASSET__mgUYVTEd__"